import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as Subaccounts from 'subaccounts/components';
import SubaccountFormHandlers from 'subaccounts/containers/SubaccountFormHandlers';

import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups

import { getIsSaving, getIsFetching, getEditing, getIsFetchingConfig } from 'subaccounts/selectors';
import { getVisibleAccountsParent, getVisibleDepreciations } from 'selectors/lists';
import { getCompany, getSubcompany } from 'auth/selectors';

class SubaccountsFormContainer extends Component {
  render = () => (
    <SubaccountFormHandlers
      render={({
        isSubmitted,
        isSaving,
        handleValueChange,
        handleValidation,
        handleSubmit,
        handleGroupChange, //Groups
        handleCustomFieldChange, //Groups
        handleRemoveCustomField,
        handleAddCustomField,
      }) => (
        <Subaccounts.FormView
          subcompany={this.props.subcompany}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          isFetching={this.props.isFetching}
          handleValueChange={handleValueChange}
          handleValidation={handleValidation}
          handleSubmit={handleSubmit}
          handleRemoveCustomField={handleRemoveCustomField}
          handleAddCustomField={handleAddCustomField}
          depreciations={this.props.depreciations}
          company={this.props.company}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={this.props.groups} //Groups
          accounts={this.props.accounts}
          subaccount={this.props.subaccount}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  subaccount: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
  accounts: getVisibleAccountsParent(state),
  depreciations: getVisibleDepreciations(state),
});

export default connect(mapStateToProps, null)(SubaccountsFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/containers/SubaccountsFormContainer.js